import React, { useMemo } from 'react';
import { Button, HStack, Stack, useDisclosure } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { useTokens } from '../../../../context/TokenProvider';
import SearchBar from '../../../modules/SearchBar/SearchBar';
import { localise } from '../../../../services/lang/lang';
import { INSPECTION_LIST_TABLE_HEADERS } from '../../../modules/InspectionsTable/InspectionsTable';
import FilterColumnMenu from '../../../modules/FilterColumnMenu/FilterColumnMenu';
import PlusIcon from '../../../icons/PlusIcon/PlusIcon';
import AddInspectionModal from './AddInspection/AddInspectionModal';
import ActionsFilterWrapper from './ActionsFilterWrapper';
import { useInspectionListingContext } from './InspectionListingProvider';
import InspectionListingDownloadButton from './InspectionListingDownloadButton';
import { PENDING } from '../../../../constants/statuses';
const InspectionListingHeader = ({ onSearch, onColumnFilterApply, onActionFilterApply, selectedColumns, selectedActionIds, statuses, }) => {
    const history = useHistory();
    const tokens = useTokens();
    const { scope, onInspectionsMutated } = useInspectionListingContext();
    const headers = useMemo(() => {
        const shownHeaders = INSPECTION_LIST_TABLE_HEADERS.filter((header) => !('showOnlyForScope' in header) || header.showOnlyForScope === scope);
        return shownHeaders.map((header) => ({
            ...header,
            isSelected: selectedColumns.includes(header.key),
        }));
    }, [selectedColumns, scope]);
    const addInspectionModal = useDisclosure();
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: { base: 'column', '2xl': 'row' }, alignItems: { base: 'stretch', '2xl': 'flex-end' }, mt: { base: '0px', '2xl': '-25px' }, spacing: { base: tokens.Spacing04, '2xl': tokens.Spacing06 }, "data-testid": "inspection-listing__header" },
            React.createElement(SearchBar, { placeholder: localise('INSPECTION_SEARCH_PLACEHOLDER'), onChange: onSearch }),
            React.createElement(HStack, { alignItems: "flex-end", spacing: { base: tokens.Spacing05, xl: tokens.Spacing06 } },
                React.createElement(ActionsFilterWrapper, { onApply: onActionFilterApply, selectedActionIds: selectedActionIds }),
                React.createElement(InspectionListingDownloadButton, { statuses: statuses }),
                React.createElement(FilterColumnMenu, { onApply: onColumnFilterApply, headers: headers, tooltipText: localise('FILTER_COLUMN_TOOLTIP') }),
                React.createElement(Button, { variant: "primary", leftIcon: React.createElement(PlusIcon, { fill: tokens.IconWhite100 }), onClick: addInspectionModal.onOpen, "data-testid": "inspection-listing-header__add-inspection-button" }, localise('ADD_INSPECTION')))),
        React.createElement(AddInspectionModal, { onSuccess: (inspection) => {
                onInspectionsMutated?.('my-inspections');
                onInspectionsMutated?.('team-inspections');
                addInspectionModal.onClose();
                if (inspection) {
                    history.push(`/inspections/${inspection.id}`);
                }
                else {
                    history.push(`/inspections/my-inspections/${PENDING}`);
                }
            }, onClose: addInspectionModal.onClose, isOpen: addInspectionModal.isOpen })));
};
export default InspectionListingHeader;
